import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/gitlab-runner/builds/Rfteai2v/0/mprog/airport-appliance_frontend/node_modules/next/dist/client/app-dir/link.js");
